exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*!\n * Copyright (c) 2020 DV Bern AG, Switzerland\n *\n * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich\n * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt\n * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in\n * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur\n * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.\n *\n */.modal-header--map{padding:25px 58px}.modal-header--map h2:after{border:none}.modal-header--map span{font-size:16px;line-height:25px;letter-spacing:1px}.modal-body--map{padding:0 58px}.modal-body--map .map{width:100%;height:350px}.modal-footer--map{text-align:center;padding:30px}@media(min-width:1025px){.map-modal-window .modal-dialog{width:60%;height:700px;left:50%;top:50%;transform:translate(-50%,-50%)!important;margin:0}}.map-modal-window ng-map{height:450px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/app/core/component/dv-geoadmin-map/dv-geoadmin-map.scss
// module id = VD7B
// module chunks = 0